import { combineReducers } from 'redux';

import router from '@giro/shared-store/router';
import toaster from '@giro/shared-store/toaster';
import auth from '@giro/shared-store/auth';

import pdv from '@giro-pdv-whitelabel/modules/pdv/store';
import login from '@giro-pdv-whitelabel/modules/login/store';
import reports from '@giro-pdv-whitelabel/modules/reports/store';
import receipt from '@giro-pdv-whitelabel/modules/receipt/store';
import cb from '@giro-pdv-whitelabel/modules/cb/store';
import configuration from '@giro-pdv-whitelabel/modules/configuration/store';
import onboardingSaga from '@giro-pdv-whitelabel/modules/onboarding/store';

import dialogReceipt from './dialogReceipt';
import menu from './menu';

const appReducer = combineReducers({
  [router.name]: router.reducer,
  [toaster.name]: toaster.reducer,
  [pdv.name]: pdv.reducer,
  [cb.name]: cb.reducer,
  [configuration.name]: configuration.reducer,
  [receipt.name]: receipt.reducer,
  [reports.name]: reports.reducer,
  [login.name]: login.reducer,
  [onboardingSaga.name]: onboardingSaga.reducer,
  [auth.name]: auth.reducer,
  [dialogReceipt.name]: dialogReceipt.reducer,
  [menu.name]: menu.reducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
